import { createContext } from 'react';

const DropdownMenuContext = createContext();

export default DropdownMenuContext;
